var AppEmbedData_AppType = /* @__PURE__ */ ((AppEmbedData_AppType2) => {
  AppEmbedData_AppType2["PRODUCT"] = "PRODUCT";
  AppEmbedData_AppType2["EVENT"] = "EVENT";
  AppEmbedData_AppType2["BOOKING"] = "BOOKING";
  AppEmbedData_AppType2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_AppType2;
})(AppEmbedData_AppType || {});
export {
  AppEmbedData_AppType
};
//# sourceMappingURL=plugin_app_embed.enums.js.map
